module.exports = __webpack_public_path__ + "img/Zsuzsi_Simon_Alexandru_07.15d663cc.jpg";